import {
  AccessScope,
  PostsInteractionScope,
  PrimaryColor,
  ThemeMode,
} from '../../../shared/constants';
import { ILanguage } from '../../../types/interfaces/language';
import { MeasurementUnitKey } from '../../../types/interfaces/user-measurement';

export enum RegistrationWizardStep {
  name = 'name',
  measurements = 'measurements',
  visualization = 'visualization',
  privacy = 'privacy',
}

export const REGISTRATION_WIZARD_STEPS: RegistrationWizardStep[] = [
  RegistrationWizardStep.name,
  RegistrationWizardStep.measurements,
  RegistrationWizardStep.visualization,
  RegistrationWizardStep.privacy,
];

export interface IRegistrationWizardValues {
  firstname: string;
  lastname: string;
  weightValue: string | number;
  weightUnitKey: MeasurementUnitKey;
  heightValue: string | number;
  heightUnitKey: MeasurementUnitKey;
  theme: ThemeMode;
  primaryColor: PrimaryColor;
  language: ILanguage | null;
  scope: AccessScope | undefined;
  postsScope: PostsInteractionScope | undefined;
  commentsScope: PostsInteractionScope | undefined;
}
